import React from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "./../context/AppCtxProvider";
const useLanguageContext = () => {
  const ctx = useAppContext();
  const { i18n } = useTranslation();
  React.useEffect(() => {
    ctx.sendValue("language", i18n.language.toLowerCase());
    ctx.sendValue("rtl", i18n.dir() === "rtl");
  }, [i18n.language]);
};
export default useLanguageContext;
